// extracted by mini-css-extract-plugin
export default {"title":"EmployeeListeningCard_title__MHduO","description":"EmployeeListeningCard_description__rgmWl"};